import { render, staticRenderFns } from "./Communications.vue?vue&type=template&id=92adfc7e"
import script from "./Communications.vue?vue&type=script&lang=js"
export * from "./Communications.vue?vue&type=script&lang=js"
import style0 from "./Communications.vue?vue&type=style&index=0&id=92adfc7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports